import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tx-list-container" }
const _hoisted_2 = { class: "filter-area" }
const _hoisted_3 = { class: "ml-2 mt-2" }
const _hoisted_4 = { class: "is-flex-direction-column is-align-items-center is-justify-content-space-between mb-2" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "datepicker-export" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "xmx-icon-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "xmx-icon-right" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "mb-1 mt-3" }
const _hoisted_15 = { class: "recipient-filter is-flex is-flex-direction-row" }
const _hoisted_16 = { class: "recipient-filter-input" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "container is-fluid custom-heavy-line-separator" }, null, -1)
const _hoisted_18 = { class: "tx-list" }
const _hoisted_19 = { class: "custom-card is-flex-direction-column is-align-items-center is-justify-content-space-between mb-4" }
const _hoisted_20 = {
  key: 1,
  class: "is-flex is-align-items-center is-justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_model_list_select = _resolveComponent("model-list-select")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_TransactionItem = _resolveComponent("TransactionItem")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$gettext("Select timespan:")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_date_picker, {
              value: _ctx.exportDate,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.exportDate) = $event)),
              open: _ctx.datePickerShow ? true : null,
              range: "",
              "prefix-class": "xmx",
              editable: false,
              placeholder: _ctx.$gettext('All transactions'),
              onClear: _cache[2] || (_cache[2] = 
                () => {
                  _ctx.selectedTimeSpanType = ''
                  _ctx.datePickerShow = false
                }
              ),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.datePickerShow = _ctx.selectedTimeSpanType ? true : false)),
              onPick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTimeSpanType = '')),
              "disabled-date": _ctx.disabledDates
            }, {
              header: _withCtx(({ emit }) => [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectorsOrder, (selector) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([{
                      selected: selector == _ctx.selectedTimeSpanType,
                    }, "timespan"])
                    }, [
                      _createElementVNode("button", {
                        class: "xmx-btn xmx-btn-text",
                        onClick: 
                        () => {
                          _ctx.selectedTimeSpanOffset =
                            _ctx.selectedTimeSpanType != selector
                              ? -1
                              : _ctx.selectedTimeSpanOffset - 1
                          _ctx.selectedTimeSpanType = selector
                          emit(_ctx.selectedTimeSpan)
                        }
                      
                      }, _hoisted_9, 8, _hoisted_7),
                      _createElementVNode("button", {
                        class: "xmx-btn xmx-btn-text",
                        onClick: 
                        () => {
                          _ctx.selectedTimeSpanType = selector
                          _ctx.selectedTimeSpanOffset = 0
                          emit(_ctx.selectedTimeSpan)
                        }
                      
                      }, _toDisplayString(_ctx.selectorLabels[selector]), 9, _hoisted_10),
                      _createElementVNode("button", {
                        class: _normalizeClass(["xmx-btn xmx-btn-text", {
                        hide:
                          _ctx.selectedTimeSpanType != selector ||
                          _ctx.isSelectionCurrent,
                      }]),
                        onClick: ($event: any) => {
                        ;[_ctx.selectedTimeSpanOffset++, emit(_ctx.selectedTimeSpan)]
                      }
                      }, _hoisted_13, 10, _hoisted_11),
                      _createElementVNode("button", {
                        class: _normalizeClass(["xmx-btn xmx-btn-text confirm", { hide: _ctx.selectedTimeSpanType != selector }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.datePickerShow = false))
                      }, _toDisplayString(_ctx.$gettext("confirm")), 3)
                    ], 2))
                  }), 256))
                ])
              ]),
              _: 1
            }, 8, ["value", "open", "placeholder", "disabled-date"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$gettext("Select recipient:")), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_model_list_select, {
                list: 
                  _ctx.recipientBatchLoader.elements.reduce((acc, r, idx) => {
                    if (_ctx.recipient?.internalId !== r.internalId)
                      acc.push({ name: r.name, idx })
                    return acc
                  }, [])
                ,
                "option-value": "idx",
                "option-text": "name",
                modelValue: _ctx.selectedRecipientIdx,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedRecipientIdx) = $event)),
                placeholder: _ctx.$gettext('All recipient'),
                onSearchchange: _ctx.onRecipientSearch,
                id: "recipientSelector"
              }, null, 8, ["list", "modelValue", "placeholder", "onSearchchange"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["recipient-filter-reset", { disable: _ctx.selectedRecipientIdx === null }]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedRecipientIdx = null))
              }, [
                (_ctx.recipientBatchLoader.isNewBatchLoading)
                  ? (_openBlock(), _createBlock(_component_fa_icon, {
                      key: 0,
                      class: "refreshing",
                      icon: "sync"
                    }))
                  : (_ctx.selectedRecipientIdx !== null)
                    ? (_openBlock(), _createBlock(_component_fa_icon, {
                        key: 1,
                        icon: "fa-xmark"
                      }))
                    : (_openBlock(), _createBlock(_component_fa_icon, {
                        key: 2,
                        icon: "fa-user"
                      }))
              ], 2)
            ])
          ])
        ])
      ]),
      _hoisted_17
    ]),
    _createElementVNode("section", {
      ref: "transactionsContainer",
      onScroll: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.transactionBatchLoader.getNextElements && _ctx.transactionBatchLoader.getNextElements(...args))),
      class: "modal-card-body"
    }, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionBatchLoader.elements, (transaction) => {
            return (_openBlock(), _createBlock(_component_TransactionItem, {
              key: transaction,
              transaction: transaction,
              account: _ctx.account
            }, null, 8, ["transaction", "account"]))
          }), 128)),
          (_ctx.transactionBatchLoader.isNewBatchLoading)
            ? (_openBlock(), _createBlock(_component_Loading, {
                key: 0,
                active: _ctx.transactionBatchLoader.isNewBatchLoading,
                "onUpdate:active": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.transactionBatchLoader.isNewBatchLoading) = $event)),
                class: "loader-container",
                "can-cancel": false,
                "is-full-page": false,
                width: 30,
                height: 30
              }, null, 8, ["active"]))
            : (
              _ctx.transactionBatchLoader.elements.length == 0 &&
              !_ctx.transactionBatchLoader.isNewBatchLoading.value
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$gettext("No transaction found")), 1))
              : _createCommentVNode("", true)
        ])
      ])
    ], 544)
  ]))
}